import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AddStaffService } from '../../services/add-staff.service';

/**
 * AddStaffWrapperComponent has @Output() manualStaff which emits true when user clicks Add staff button,
 * @Output() file emits the file with the staff that user uploads.
 */

@Component({
  selector: 'app-add-staff-wrapper',
  templateUrl: './add-staff-wrapper.component.html',
  styleUrls: ['./add-staff-wrapper.component.scss']
})
export class AddStaffWrapperComponent implements OnInit {

  @Output() manualStaff: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() file: EventEmitter<string | ArrayBuffer> = new EventEmitter<string | ArrayBuffer>();

  constructor(
    private _addStaffService: AddStaffService
  ) { }

  ngOnInit(): void { }

  acceptFile(file: string | ArrayBuffer) {
    this.file.emit(file);
  }

  setFileName(fileName: string) {
    this._addStaffService.fileName = fileName;
  }
}
